import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css";

import Title from "components/atoms/Title";

import WMUDV3 from "./WMUDV3";

export const WhatMakeUsDifferentV3 = ({
  data,
  title,
  ebookImage,
  ...props
}) => {
  return (
    <div
      className={props.className ? props.className : "bg-wmud py-12"}
      // {...props}
    >
      {title && (
        <Title text={title} className="bbc-title mb-10 px-[15px] text-center" />
      )}
      <WMUDV3 data={data} ebookImage={ebookImage} {...props} />
    </div>
  );
};
